import { render, staticRenderFns } from "./AdminActivityContainer.vue?vue&type=template&id=f1202524&scoped=true&"
import script from "./AdminActivityContainer.vue?vue&type=script&lang=js&"
export * from "./AdminActivityContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1202524",
  null
  
)

export default component.exports